import {
    PRIVILEDGE_LOADING,
    RESOURCES_LOADED,
    PRIVILEDGE_LOADED,
    PRIVILEDGE_DETAILS,
    PRIVILEDGE_EDITED,
    PRIVILEDGE_DELETED,
    PRIVILEDGE_FAILED,
    PERMISSION_ADDED,
    PRIVILEDGE_CREATED,
    PERMISSION_REMOVED,
    LOGOUT,
} from '../types';

import { editedUpdate, deleteFromState } from '../../helpers/reduxUtils';

const initialState = {
    loading: false,
    success: false,
    allPriviledges: [],
    resources: [],
    details: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PRIVILEDGE_LOADING:
            return {
                ...state,
                success: false,
                loading: true,
            };
        case RESOURCES_LOADED:
            return {
                ...state,
                loading: false,
                resources: action.payload,
            };
        case PRIVILEDGE_LOADED:
            return {
                ...state,
                details: null,
                loading: false,
                allPriviledges: action.payload,
            };
        case PRIVILEDGE_DETAILS:
            return {
                ...state,
                loading: false,
                success: false,
                details: action.payload,
            };
        case PRIVILEDGE_CREATED:
        case PERMISSION_REMOVED:
        case PRIVILEDGE_EDITED:
        case PERMISSION_ADDED:
            return {
                ...state,
                loading: false,
                success: true,
                details: null,
                allPriviledges: editedUpdate(state.allPriviledges, action.payload),
            };
        case PRIVILEDGE_DELETED:
            return {
                ...state,
                loading: false,
                allPriviledges: deleteFromState(state.allPriviledges, action.payload),
            };
        case PRIVILEDGE_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
            };
        case LOGOUT:
            return {
                loading: false,
                success: false,
                allPriviledges: [],
                details: null,
            };

        default:
            return state;
    }
}